import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { Country } from "../model/Country";
import { CountriesSuccessResponse } from "./api-response/CountriesSuccessResponse";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { map } from "rxjs/operators";

export class ApiCountry {
  constructor(private apiEndpoint: string) {}

  listAll(token: string): Observable<Country[]> {
    return ajax({
      url: `${this.apiEndpoint}/countries`,
      method: "GET",
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(
      map((x) => x.response),
      map((x: CountriesSuccessResponse) => x.countries.items)
    );
  }
}
